import Select, { SingleValue } from 'react-select';
import useProxyPoolCreationForm from '../../store/proxyPoolCreationFormStore';
import {
  proxyPoolRotationOptions,
  ProxyPoolRotationSchema,
} from '@fd/common/biz/proxyPoolRotationOptions';

export default function RotationSelect() {
  const { rotation, setRotation } = useProxyPoolCreationForm();

  const handleChange = (
    option: SingleValue<{ value: number; label: string }> | null
  ) => {
    try {
      const newRotation = ProxyPoolRotationSchema.parse(option?.value);
      setRotation(newRotation);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Select
      value={proxyPoolRotationOptions.filter((o) => o.value === rotation)[0]}
      onChange={handleChange}
      options={proxyPoolRotationOptions}
      placeholder="Select rotation type"
      isSearchable={false}
    />
  );
}
